// Core Imports
import { useEffect, useContext } from "react";

// Cookie Handling
import CryptoJS from 'crypto-js';
import Cookies from "universal-cookie";

// Context
import { UserContext } from "../context/UserContext";

// Custom hook that checks the user's permissions for the current page
const useVerifyUserPermissions = (manager = false) => {

    const permissions = manager ? ["is_macrodyne", "is_superuser", "is_manager"] : ["is_macrodyne", "is_superuser"];

    // Declare cookie instance
    const cookies = new Cookies();

    // Get stored cookie
    const storedCookie = cookies.get("user");

    const { setRedirectUser } = useContext(UserContext);

    useEffect(() => {
        if (storedCookie) {

            const decryptedCookie = JSON.parse(CryptoJS.AES.decrypt(storedCookie, process.env.REACT_APP_ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8));

            // Superusers have access to the whole website
            const hasPermission = permissions.some((permission) => {
                return decryptedCookie[permission];
            })

            setRedirectUser(!hasPermission);
        }
    })


}

export default useVerifyUserPermissions